import React from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";

const MapPage = () => {
    // Get lat/lng from URL params
    const queryParams = new URLSearchParams(window.location.search);
    const lat = parseFloat(queryParams.get("lat"));
    const lng = parseFloat(queryParams.get("lng"));

    if (!lat || !lng) {
        return <p className="p-4 text-red-500">Invalid coordinates</p>;
    }

    return (
        <div className="w-screen h-screen">
            <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                <Map
                    defaultCenter={{ lat, lng }}
                    defaultZoom={15}
                    className="w-full h-full"
                >
                    <Marker position={{ lat, lng }} />
                </Map>
            </APIProvider>
        </div>
    );
};

export default MapPage;
